// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 * @type ExtractDatasetInputResolution
 *
 * @export
 */
export type ExtractDatasetInputResolution = number | string;

export function ExtractDatasetInputResolutionFromJSON(json: any): ExtractDatasetInputResolution {
  return ExtractDatasetInputResolutionFromJSONTyped(json, false);
}

export function ExtractDatasetInputResolutionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractDatasetInputResolution {
  if (json == null) {
    return json;
  }
  if (typeof json === "number") {
    return json;
  }
  if (typeof json === "string" && json === "default") {
    return json;
  }
  return {} as any;
}

export function ExtractDatasetInputResolutionToJSON(json: any): any {
  return ExtractDatasetInputResolutionToJSONTyped(json, false);
}

export function ExtractDatasetInputResolutionToJSONTyped(
  value?: ExtractDatasetInputResolution | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  if (typeof value === "number") {
    return value;
  }
  if (typeof value === "string" && value === "default") {
    return value;
  }
  return {};
}
